import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AvatarComponent } from 'src/app/_shared/components/avatar/avatar.component';
import { ButtonComponent } from 'src/app/_shared/components/button/button.component';
import { ButtonContentComponent } from 'src/app/_shared/components/button/components/button-content.component';
import { CardBaseComponent } from 'src/app/_shared/components/card/card-base/card-base.component';
import { ModalRef } from 'src/app/_shared/components/modal/modal-ref';
import { IndicationScheduleWithDocuments } from 'src/app/_pages/private/indication/contracts/indication';
import { IndicationsService } from 'src/app/services/indications.service';

@Component({
  selector: 'app-ui-indication-laudos-modal',
  standalone: true,
  imports: [CommonModule, AvatarComponent, ButtonComponent, ButtonContentComponent, CardBaseComponent],
  templateUrl: './ui-indication-laudos-modal.component.html',
  styleUrls: ['./ui-indication-laudos-modal.component.scss'],
})
export class UiIndicationLaudosModalComponent implements OnInit {
  indicationId: number;
  patientName = '';
  cpf = '';

  loading = true;
  errorMessage: string | null = null;
  schedules: IndicationScheduleWithDocuments[] = [];

  constructor(
    private readonly modalRef: ModalRef<void>,
    private readonly indicationsService: IndicationsService
  ) {}

  ngOnInit(): void {
    this.indicationsService.getIndicationSchedules(this.indicationId).subscribe({
      next: (schedules) => {
        this.schedules = schedules;
        this.loading = false;
      },
      error: () => {
        this.errorMessage = 'Não foi possível carregar os laudos.';
        this.loading = false;
      },
    });
  }

  trackByScheduleId(_index: number, schedule: IndicationScheduleWithDocuments): number {
    return schedule.id;
  }

  openDocument(url: string): void {
    window.open(url, '_blank');
  }

  close(): void {
    this.modalRef.close();
  }
}
